// src/pages/categories/components/CategoryItem/CategoryItem.tsx

import React from "react";
import { Link } from "react-router-dom";
import { CategoryInterface } from "../../../../common/types/types";
import { getImageUri } from "../../../../common/utils/functions/getImageUri";
import { shortenText } from "../../../../common/utils/functions/shortenText";
import styles from "./CategoryItem.module.scss";

type Props = {
  category: CategoryInterface;
};

const CHILDREN_LIMIT =120;

/**
 * Собирает строку имён детей, обрезает до лимита, считает +N
 */
function buildChildrenLine(children: CategoryInterface[], limit: number) {
  if (children.length === 0) return { text: "", hidden: 0 };

  const fullLine = children.map((c) => c.name).join(", ");

  if (fullLine.length <= limit) {
    return { text: fullLine, hidden: 0 };
  }

  let text = "";
  let visibleCount = 0;

  for (let i = 0; i < children.length; i++) {
    const candidate =
      i === 0 ? children[i].name : `${text}, ${children[i].name}`;

    if (candidate.length <= limit) {
      text = candidate;
      visibleCount++;
    } else {
      break;
    }
  }

  if (visibleCount === 0) {
    text = shortenText(children[0].name, limit);
    visibleCount = 1;
  }

  const hidden = children.length - visibleCount;
  return { text, hidden };
}

export default function CategoryItem({ category }: Props) {
  const children = (category.children || []) as CategoryInterface[];

  const { text: childrenText, hidden: hiddenCount } = buildChildrenLine(
    children,
    CHILDREN_LIMIT,
  );

  return (
    <Link
      to={`/category/${category.id}`}
      className={styles.container}
      aria-label={`Перейти в категорию ${category.name}`}
    >
      {category.files?.[0] ? (
        <img
          src={`${getImageUri()}${category.files[0]}`}
          alt={category.name}
          className={styles.image}
        />
      ) : (
        <div className={styles.imagePlaceholder}>
          <span className={styles.placeholderText}>Нет фото</span>
        </div>
      )}

      <div className={styles.contentBlock}>
        <span className={styles.name}>{category.name}</span>
        {category.description && (
          <p className={styles.description}>{category.description}</p>
        )}

        {childrenText && (
          <div className={styles.childrenLine}>
            {childrenText}
            {hiddenCount > 0 && (
              <span className={styles.more}> +{hiddenCount}</span>
            )}
          </div>
        )}
      </div>
    </Link>
  );
}